import { siteConfig } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20calligraphy%20on%20aged%20rice%20paper%20with%20ink%20wash%20texture%2C%20traditional%20Chinese%20seal%20script%20characters%20floating%20subtly%20in%20background%2C%20warm%20sepia%20and%20ink%20black%20tones%2C%20artistic%20bokeh%20effect%2C%20scholarly%20atmosphere%2C%20soft%20diffused%20lighting%2C%20elegant%20traditional%20Chinese%20aesthetic&width=1600&height=900&seq=hero-yin-background&orientation=landscape"
          alt="淫字文化溯源 - 汉字文化研究"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 text-center px-4 w-full">
        <div className="mb-6 md:mb-8">
          <span className="inline-block font-calligraphy text-8xl md:text-9xl text-background-50 leading-none animate-[fadeIn_1s_ease-out]">
            淫
          </span>
        </div>
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3 md:mb-4 tracking-wide">
          {siteConfig.tagline}
        </h1>
        <p className="text-sm md:text-base text-background-200/80 max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {siteConfig.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/zixing-yanbian"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            探索字形演变
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
          <Link
            to="/category/yuyi-jiexi"
            className="px-6 py-2.5 bg-background-50/15 text-background-50 backdrop-blur-sm rounded-md text-sm font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            深入语义解析
          </Link>
        </div>
        <div className="mt-10 md:mt-12 flex items-center justify-center gap-6 md:gap-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">12</p>
            <p className="text-xs text-background-300/70 mt-1">篇研究文章</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">5</p>
            <p className="text-xs text-background-300/70 mt-1">大研究板块</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">3000+</p>
            <p className="text-xs text-background-300/70 mt-1">年文字历史</p>
          </div>
        </div>
      </div>
    </section>
  );
}